import { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./ScrollToTop.jsx";
import Layout from "./components/Layout";
// import PageTracker from "./components/PageTracker.js";
import "./App.css";
import { setLanguage } from "./data/languageSlice.js";
import Home from "./pages/Home.jsx";
import ListingCruises from "./pages/booking-pages/ListingCruises.jsx";
// import ContactUs from "./pages/ContactUs.jsx";
import CruisesDetails from "./pages/booking-pages/CruisesDetails.jsx";
import Checkout from "./pages/booking-pages/Checkout.jsx";
import BookingConfirmation from "./pages/BookingConfirmation.jsx";
import AddExtra from "./pages/booking-pages/AddExtra.jsx";
// import AboutUs from "./pages/AboutUs.jsx";
// import BecomePartner from "./pages/BecomePartner.jsx";
// import HelpCenter from "./pages/HelpCenter.jsx";
// import TermsAndConditions from "./pages/TermsAndConditions.jsx";
// import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
// import HowWeWork from "./pages/HowWeWork.jsx";
// import Error from "./pages/Error.jsx";
// import Signup from "./pages/Signup.jsx";
// import Signin from "./pages/Signin.jsx";
// import Test from "./pages/Test.jsx";

import { fetchDurations } from "./data/durationsSlice.js";

// import "../node_modules/swiper/swiper-bundle.min.css";
// import CruiseBooking from "./components/cruiseBooking/CruiseBooking.jsx";
// import CabinBooking from "./components/cruiseBooking/CabinBooking.jsx";
// import InsertCstData from "./components/cruiseBooking/InsertCstData.jsx";
// import ThanksPage from "./components/cabinsBooking/ThanksPage.jsx";
// import BookingSearch from "./pages/BookingSearch.jsx";
// import AddExtra from "./components/cruiseBooking/AddExtra.jsx";
// import FilterTypes from "./pages/1filter-types/FilterTypes.jsx";
// import Offers from "./pages/Offers.jsx";
import { Seat } from "./pages/Seat.jsx";
import TagManager from "react-gtm-module";
import { fetchConfiguration } from "./data/configurationSlice.js";

const tagManagerArgs = {
  gtmId: "GTM-5PWCGC45", // استبدل بـ GTM الخاص بيك
};
export const BrandColorContext = createContext();
function App() {
  // useEffect(() => {

  //   const cursor = document.createElement("div");
  //   cursor.classList.add("custom-cursor");
  //   document.body.appendChild(cursor);

  //   function updateCursorPosition(e) {
  //     cursor.style.left = e.clientX + "px";
  //     cursor.style.top = e.clientY + "px";
  //   }

  //   // إضافة مستمع الحدث
  //   document.addEventListener("mousemove", updateCursorPosition);

  //   // تنظيف عند إزالة المكون
  //   return () => {
  //     document.removeEventListener("mousemove", updateCursorPosition);
  //     document.body.removeChild(cursor);
  //   };
  // }, []);
  // const queryString = new URLSearchParams({
  //   chainId: "m2025",
  // }).toString();
  const language = useSelector((state) => state.language.language);
  const configuration = useSelector(
    (state) => state.configuration.configuration
  );
  // console.log(configuration);
  const [basename, setBasename] = useState("/");
  const dispatch = useDispatch();

  const currentUrl = new URL(window.location.href);
  const queryString = new URLSearchParams(currentUrl.search);
  const chainCode = queryString.get("chainCode");
  const langParam = queryString.get("lang");
  useEffect(() => {
    dispatch(fetchDurations(chainCode));
    dispatch(fetchConfiguration(chainCode));
  }, [dispatch, chainCode]);

  // useEffect(() => {
  //   const currentUrl = new URL(window.location.href);
  //   const queryParams = new URLSearchParams();

  //   if (!queryParams.has("lang")) {
  //     queryParams.set("lang", "en");
  //   }

  //   if (chainCode) {
  //     queryParams.set("chainCode", chainCode);
  //   }

  //   const cleanParams = queryParams.toString();
  //   if (currentUrl.search !== `?${cleanParams}`) {
  //     window.location.href = `${currentUrl.origin}${currentUrl.pathname}${
  //       cleanParams ? `?${cleanParams}` : ""
  //     }`;
  //   }

  //   // Update language state
  //   const currentLang = queryParams.get("lang");
  //   if (["en", "eg", "de", "ru"].includes(currentLang)) {
  //     dispatch(setLanguage(currentLang));
  //   }
  // }, [dispatch, chainCode]);
  useEffect(() => {
    const head = document.head;
    const stylesheets = {
      eg: {
        id: "eg-stylesheet",
        href: "bootstrap-rtl.min.css",
      },
      ru: {
        id: "ru-stylesheet",
        href: "ru.css",
      },
    };

    // Remove all previously added stylesheets
    Object.values(stylesheets).forEach(({ id }) => {
      const existingLink = document.getElementById(id);
      if (existingLink) {
        head.removeChild(existingLink);
      }
    });
    if (stylesheets[language]) {
      const { id, href } = stylesheets[language];
      let link = document.createElement("link");
      link.id = id;
      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = href;
      head.appendChild(link);
    }
  }, [language]);
  // useEffect(() => {
  //   fetch("https://your-api.com/brand-color")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       document.documentElement.style.setProperty("--brand-color", data.color);
  //     });
  // }, []);

  const [brandColor, setBrandColor] = useState("#1976d2");
  const svgUrl = `data:image/svg+xml,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="1600" height="198">
      <defs>
        <linearGradient id="a" x1="50%" x2="50%" y1="-10.959%" y2="100%">
          <stop stop-color="${brandColor}" stop-opacity=".25" offset="0%"/>
          <stop stop-color="${brandColor}" offset="100%"/>
        </linearGradient>
      </defs>
      <path fill="url(#a)" fill-rule="evenodd" d="M.005 121C311 121 409.898-.25 811 0c400 0 500 121 789 121v77H0s.005-48 .005-77z" transform="matrix(-1 0 0 1 1600 0)"/>
    </svg>
  `)}`;
  useEffect(() => {
    if (chainCode) {
      setBrandColor(configuration?.companyPrimaryColor);
      // document.documentElement.style.setProperty("--brand-color", data.color);
      document.documentElement.style.setProperty("--color-dark-3", brandColor);
      document.documentElement.style.setProperty("--color-dark-4", brandColor);
      document.documentElement.style.setProperty("--color-blue-1", brandColor);
      document.documentElement.style.setProperty("--rs-text-link", brandColor);

      const style = document.createElement("style");
      style.type = "text/css";
      style.innerHTML = `path[Attributes Style] { fill: ${brandColor} !important; }`;
      style.innerHTML = `svg { fill: ${brandColor} !important; }`;

      style.innerHTML = `.text-primary { color:  ${brandColor} !important; }`;

      style.innerHTML = `.text-main { color:  ${brandColor}  !important;}`;
      style.innerHTML = `.css-1hw9j7s { background-color:  ${brandColor} !important; }`;
      style.innerHTML = `::-webkit-scrollbar-thumb { background-color:  ${brandColor} !important; }`;

      style.innerHTML = `.masthead .x h1 {color:  ${brandColor} !important;
      
    }`;
      // style.innerHTML = `.masthead h1 {background-image: url("${svgUrl}") !important;
      document.head.appendChild(style);

      return () => {
        document.head.removeChild(style);
      };
    } else {
      setBrandColor("#1976d2");
    }
  }, [chainCode, brandColor, configuration?.companyPrimaryColor, svgUrl]);

  useEffect(() => {
    TagManager.initialize(tagManagerArgs);
  }, []);
  return (
    <HelmetProvider>
      {" "}
      <Router basename={basename}>
        {/* <PageTracker /> */}
        <ScrollToTop />
        <BrandColorContext.Provider value={brandColor}>
          <Routes>
            {/* <Route path="/" element={<Layout />}>  */}
            {/* <Route index element={<Home />} /> */}
            <Route index element={<Home />} />
            <Route path="/" element={<Layout />}>
              {/* <Route
                path="cruise-type/:cruiseTypeUrl"
                element={<FilterTypes />}
              /> */}
              <Route path="booking-cruises" element={<ListingCruises />} />
              <Route path="seat" element={<Seat />} />
              <Route path="cruises-details" element={<CruisesDetails />} />
              <Route path="add-extra" element={<AddExtra />} />
              <Route path="checkout" element={<Checkout />} />
              <Route
                path="booking-confirmation"
                element={<BookingConfirmation />}
              />
              {/* <Route path="special-offers" element={<Offers />} />
                <Route path="about-us" element={<AboutUs />} />
              <Route path="become-partner" element={<BecomePartner />} />
             <Route path="help-center" element={<HelpCenter />} />
              <Route path="contact-us" element={<ContactUs />} />
              <Route
                path="terms-and-conditions"
                element={<TermsAndConditions />}
              />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="how-we-work" element={<HowWeWork />} /> */}
              {/* <Route path="signup" element={<Signup />} />  */}
              {/* <Route path="signin" element={<Signin />} />  */}
              <Route path="*" element={<Navigate to="/" />} />
            </Route>

            {/* <Route path="test" element={<Test />} />
          <Route path="test2" element={<MagazineViewer />} /> */}
          </Routes>
        </BrandColorContext.Provider>
      </Router>
    </HelmetProvider>
  );
}

export default App;

/*<Route path="booking-cruises" element={<CruiseBooking />} />
<Route path="booking-cabins" element={<CabinBooking />} />
<Route path="add-extra" element={<AddExtra />} />
<Route path="booking-information" element={<InsertCstData />} />
<Route path="booking-completed" element={<ThanksPage />} />*/
